import axios, { AxiosError, type AxiosInstance } from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL || '/api'

export const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30_000,
  // Arrays viram chaves repetidas (tag_id=1&tag_id=2) — formato esperado
  // pelo Gin (c.QueryArray) no backend, em vez de tag_id[]=1&tag_id[]=2.
  paramsSerializer: { indexes: null },
})

let isRefreshing = false
let waiters: Array<(ok: boolean) => void> = []

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError) => {
    const original: any = error.config
    if (
      error.response?.status === 401 &&
      original &&
      !original.__isRetry &&
      !original.url?.includes('/auth/')
    ) {
      original.__isRetry = true
      try {
        if (!isRefreshing) {
          isRefreshing = true
          await api.post('/auth/refresh')
          isRefreshing = false
          waiters.forEach((w) => w(true))
          waiters = []
        } else {
          await new Promise<void>((resolve, reject) => {
            waiters.push((ok) => (ok ? resolve() : reject(new Error('refresh falhou'))))
          })
        }
        return api(original)
      } catch (e) {
        isRefreshing = false
        waiters.forEach((w) => w(false))
        waiters = []
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)
